module.exports = __webpack_public_path__ + "static/media/_nagorno-karabakh.804f5e0f.png";